import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule} from 'devextreme-angular';
import {CtlGenKontrolAramaComponent} from './ctl-gen-kontrol-arama/ctl-gen-kontrol-arama.component';
import {GenKontrolService} from './ctl-gen-kontrol.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {ControlConditionModel} from '../../../models/gen-control.model';
import {DkGlobalUserSettingsService} from '../../../services/dk-global-user-settings.service';
import {Subject, takeUntil} from "rxjs";
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-gen-kontrol',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGenKontrolAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent
  ],
  providers: [GenKontrolService],
  templateUrl: './ctl-gen-kontrol.component.html',
  styleUrls: ['./ctl-gen-kontrol.component.scss'],
})
export class CtlGenKontrolComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  public crudPopupVisible = false;
  public title!: string;
  public isFirst = true;
  public filterColumnValue: any;
  public searchPopupFirstCheck = 0;
  public control!: any;
  public data: any;
  @Input() code: any;
  @Input() selectMode: any;
  @Input() autoFocusOn: boolean=false;
  @Input() period!: number;
  @Input() labelText = "";
  @Input() notFoundMessage = "Bulunamadı";
  @Input() labelMode: LabelMode = this.globalSettings.globalLabelMode;
  @Input() codeField = "";
  @Input() codeFieldDesc = "";
  @Input() codeFieldDescTitles:string[] =[];
  @Input() controlName = "";
  @Input() conditionColName: any;
  @Input() conditionColText: any;
  @Input() controlCondition: ControlConditionModel[];
  @Input() normalFilterArr: any;
  @Input() isResetControlCond = false;
  @Input() resetFields!: string[];
  @Input() isReadOnly = false;
  @Input() width = "70vw";
  @Input() codeAreaWidth:any;
  @Input() height = "70vh";
  @Input() spaceBetweenDesc = false;
  @Input() type = "string";
  @Input() filterColumn = "";
  @Input() key!: string;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() isShowMap = false;
  @Input() customSearchShow = false;
  @Input() customSearchInfo = "";
  @Input() customQuery:string = "";
  @Input() warningMessage: string | null = null;
  @Input() tabIndex:number;
  // İsteğe bağlı: aynı koda birden çok kayıt dönebilen kontroller için (ör. abonenin birden çok sözleşmesi).
  // DevExtreme süzgeci (ör. ['SozlesmeIptalTarih', '=', null]); yazılan kod önce bu süzgeçle SUNUCUDA sorgulanır
  // (sayfalamaya takılmaz). Tek kayıt dönerse o seçilir; dönmezse ya da birden çok dönerse koda ait kayıtlara bakılır:
  // tek kayıt varsa o seçilir, birden çoksa ve kullanıcı yazdıysa arama popup'ı yazılan kodla süzülü açılır.
  // Verilmezse eski davranış (ilk kayıt) aynen sürer.
  @Input() tercihFiltresi: any[] | null = null;
  // tercihFiltresi ile açılan popup'ın grid süzgeci (popup kapanınca sıfırlanır)
  public aramaFiltresi: any[] | null = null;
  @Output() public showMapBtn: EventEmitter<any> = new EventEmitter();
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  private suppressValueChange = false;

  private lastRequestId = 0;

  private destroy$ = new Subject<void>();

  constructor(private service: GenKontrolService, private utilsService: UtilsService,
              private globalSettings: DkGlobalUserSettingsService,
              private ortakService:OrtakService
  ) {
  }

  ngOnInit(): void {
    if (this.period) this.service.period = this.period;
    if (this.controlName) {
      // getControl() burada çağrılmıyor: controlName her zaman template'te bağlı olduğu
      // için ngOnChanges ilk yüklemede zaten çağırıyor - burada tekrar çağırmak
      // GetControlMetadata_Request'in her kullanımda 2 kere atılmasına sebep oluyordu.
      this.setParams();
    }
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  setParams() {
    this.service.conditionColName = this.conditionColName;
    this.service.conditionColText = this.conditionColText;
    this.service.controlCondition = this.controlCondition;
    this.service.normalFilterArr = this.normalFilterArr;
    this.service.customQuery = this.customQuery;
    this.service.isReadOnly = this.isReadOnly;


  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['controlName']) {
      if (this.controlName) {
        this.getControl();
      }
    }
    if (changes['period']) {
      if (this.period) {
        this.service.period = this.period;
      }
    }
    if ( (changes['controlCondition'])) {
      this.setParams();
    }
    if((changes['normalFilterArr'])){
      this.setParams();
    }
    if ( (changes['isReadOnly'])) {
      this.setParams();
    }
    if (changes['conditionColName'] && changes['conditionColText']) {
      if (this.conditionColName || this.conditionColText) this.setParams();
    }
    if ((changes['conditionColName'] || changes['conditionColText'])) {
      this.setParams();
    }if (changes['customQuery']) {
      this.setParams(); // Burada customQuery'ye göre API'den tekrar veri çek
    }
  }
  changeControl(e:any){
    this.control = e;
    this.service._gridControlsList.next(e.dlistMetadata)
    if (e.dlistMetadata.baseEntity) {
      if (this.labelText === "") this.labelText = this.control.controlDescription;
      if (this.code && this.control) {

          this.suppressValueChange = true;
          this.getData(this.code,true);
          Promise.resolve().then(() => this.suppressValueChange = false);

      }
      if (this.isFirst) this.isFirst = false;
    }
  }
  getControl() {
    this.ortakService.getControl(this.controlName).pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if(data.controlMetadata.dlistMetadata){
          data.controlMetadata.dlistMetadata.editMode = "custom";
        }
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) {
              this.suppressValueChange = true;
              this.getData(this.code,true);
              Promise.resolve().then(() => this.suppressValueChange = false);
          }
          if (this.isFirst) this.isFirst = false;
        }
      });
  }

  searchClick() {
    this.crudPopupVisible = true;
    if (this.isResetControlCond) {
      if (this.resetFields?.length) {
        this.controlCondition = this.controlCondition?.filter(
          (condition) => !this.resetFields?.includes(condition.conditionColName)
        );
      }
      this.setParams()
    }

    this.crudPopupVisible = true
  }

  clear() {
    this.suppressValueChange = true;

    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);

    Promise.resolve().then(() => this.suppressValueChange = false);
  }

  handleValueChange(e: any) {

    if (this.suppressValueChange) {
      return; // programatik değişiklik, yoksay
    }

    this.searchPopupFirstCheck = 2;

    if (!e) {
      this.clear();
      return;
    }

    if (this.filterColumn?.length > 0) {
      this.getData(e);
    } else if (!this.isFirst) {
      this.getData(e);
    }

    this.isFirst = false;
  }


  getData(code: any, isSetData?: boolean) {
    if (this.tercihFiltresi && !(this.filterColumn?.length > 0)) {
      this.tercihliGetData(code, isSetData);
      return;
    }
    const requestId = ++this.lastRequestId;

    this.data = this.service.getData(this.filterColumn, code, this.control, this.type, this.codeField, this.key,isSetData);
    this.data.load().then((result: any) => {
      if (requestId !== this.lastRequestId){
        return;
      }
      if (this.filterColumn.length > 0) {
        if (result?.length === 1) {
          this.setTitle(result[0]);
          this.suppressValueChange = true;
          this.code = result[0][this.codeField ? this.codeField : this.control.kodField];
          Promise.resolve().then(() => this.suppressValueChange = false);
          this.isFirst = true
          this.dataResult.emit(result[0]);
        } else if (this.code && this.code.length > 0) {

          if (this.filterColumn.length > 0) {
            this.filterColumnValue = code;
            if (this.searchPopupFirstCheck >= 2) {

              this.dataResult.emit(null);
              this.code=null
              this.searchClick();
            }
            this.searchPopupFirstCheck = this.searchPopupFirstCheck + 1;
          } else {
            this.utilsService.showError(this.notFoundMessage);
            this.clear();
          }
        }
      } else {

        if (result?.length > 0) {
          this.setTitle(result[0])
          this.suppressValueChange = true;
          this.code = result[0][this.codeField ? this.codeField : this.control.kodField];
          Promise.resolve().then(() => this.suppressValueChange = false);
          this.dataResult.emit(result[0]);
        } else if (this.code && this.code.length > 0) {
          this.utilsService.showError(this.notFoundMessage);
          this.clear();
        }
      }


    });
  }

  // tercihFiltresi yolu: önce kod + tercih süzgeci; tek kayıt yoksa koda ait kayıtlara bakılır
  private tercihliGetData(code: any, isSetData?: boolean) {
    const requestId = ++this.lastRequestId;
    const kullaniciYazdi = !isSetData && !!this.ctlSablonComponent?.isUserInput;
    this.data = this.service.getData(this.filterColumn, code, this.control, this.type, this.codeField, this.key, isSetData, this.tercihFiltresi);
    this.data.load().then((tercihSonuc: any[]) => {
      if (requestId !== this.lastRequestId) return;
      if (tercihSonuc?.length === 1) {
        this.kayitSec(tercihSonuc[0]);
        return;
      }
      this.data = this.service.getData(this.filterColumn, code, this.control, this.type, this.codeField, this.key, isSetData);
      this.data.load().then((result: any[]) => {
        if (requestId !== this.lastRequestId) return;
        if (!result?.length) {
          if (this.code && String(this.code).length > 0) {
            this.utilsService.showError(this.notFoundMessage);
            this.clear();
          }
        } else if (result.length === 1) {
          // Koda ait tek kayıt var (tercihe uymasa da, ör. tek ve kapalı sözleşme): popup'sız o seçilir
          this.kayitSec(result[0]);
        } else if (kullaniciYazdi) {
          // Birden çok kayıt, hiçbiri/birden çoğu tercihe uyuyor: kişi kontrolündeki gibi yazılan kodla süzülü popup
          this.tercihsizAramaAc(code);
        } else {
          // Binding ile gelen kodda popup açılmaz; eski davranışla ilk kayıt
          this.kayitSec(result[0]);
        }
      });
    });
  }

  private kayitSec(kayit: any) {
    this.setTitle(kayit);
    this.suppressValueChange = true;
    this.code = kayit[this.codeField ? this.codeField : this.control.kodField];
    Promise.resolve().then(() => this.suppressValueChange = false);
    this.dataResult.emit(kayit);
  }

  private tercihsizAramaAc(code: any) {
    const alan = this.codeField ? this.codeField : this.control.kodField;
    this.aramaFiltresi = [alan, '=', this.type === 'number' ? Number(code) : code];
    this.suppressValueChange = true;
    this.title = '';
    this.code = null;
    Promise.resolve().then(() => this.suppressValueChange = false);
    this.dataResult.emit(null);
    this.searchClick();
  }

  private setTitle(result: any): void {
    this.title = ''; // Title sıfırlanıyor
    const isMultipleColumns = this.control.descriptionField.includes(',');
    if (isMultipleColumns) {
      const allColumns: string[] = this.control.descriptionField.split(',');
      allColumns.forEach((item: string, index:number) => {
        if (item.includes('.')) {
          const descArray = item.split('.');
          if (this.title) {
            this.title += this.spaceBetweenDesc
              ? ` ${result[descArray[0]][descArray[1]]}`
              : ` / ${result[descArray[0]][descArray[1]]}`;
          } else {
            this.title = result[descArray[0]][descArray[1]];
          }
        } else {
          if (this.title) {
            this.title += this.spaceBetweenDesc ? ` ${(result[item]?result[item]:'-')}` :
              ` / ${(this.codeFieldDescTitles.length >= (index +1))?this.codeFieldDescTitles[index]+ `${(this.codeFieldDescTitles[index].length>0)?':':''}` + (result[item]?result[item]:'-'):(result[item]?result[item]:'-')}`;
          } else {
            this.title = (this.codeFieldDescTitles.length>0)?(this.codeFieldDescTitles[0]+`${(this.codeFieldDescTitles[0].length>0)?':':''}`)+(result[item]?result[item]:'-'):(result[item]?result[item]:'-');
          }
        }
      });
    } else {
      const alterTitle = this.control.descriptionField.includes('.');
      if (alterTitle) {
        const allColumns: string[] = this.control.descriptionField.split('.');
        this.title = result[allColumns[0]][allColumns[1]];
      } else {
        this.title = result[this.codeFieldDesc ? (this.codeFieldDesc?this.codeFieldDesc:'-'):
          (this.control.descriptionField?this.control.descriptionField:'-')];
      }
    }
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.suppressValueChange = true;
      this.code = result.data[this.codeField ? this.codeField : this.control.kodField];
      Promise.resolve().then(() => this.suppressValueChange = false);
      this.setTitle(result.data);
      this.crudPopupVisible = false;
      this.isFirst = true
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    this.filterColumnValue = undefined;
    this.aramaFiltresi = null;
      this.suppressValueChange = true;
      sablonCmp.focusInput();
      Promise.resolve().then(() => this.suppressValueChange = false);
  }

  showMapClick(e: any) {
    this.showMapBtn.emit(e);
  }

  setAutoFocus(value:boolean){
    this.autoFocusOn=value
  }

  focusInput() {
    this.ctlSablonComponent?.focusInput();
  }

}
